/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramAuthControllerAuthorizeByFirebaseMutationRequest,
  TelegramAuthControllerAuthorizeByFirebaseMutationResponse,
  TelegramAuthControllerAuthorizeByFirebase401,
  TelegramAuthControllerAuthorizeByFirebase403,
} from '../../types/TelegramAuthControllerAuthorizeByFirebase.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramAuthAuthorizeByFirebase } from '../../methods/telegramAuthAuthorizeByFirebase.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramAuthAuthorizeByFirebaseMutationKey = () => [{ url: '/api/telegram/auth/firebase' }] as const;

export type TelegramAuthAuthorizeByFirebaseMutationKey = ReturnType<typeof telegramAuthAuthorizeByFirebaseMutationKey>;

/**
 * {@link /api/telegram/auth/firebase}
 */
export function useTelegramAuthAuthorizeByFirebase<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramAuthControllerAuthorizeByFirebaseMutationResponse,
      ResponseErrorConfig<TelegramAuthControllerAuthorizeByFirebase401 | TelegramAuthControllerAuthorizeByFirebase403>,
      { data: TelegramAuthControllerAuthorizeByFirebaseMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<TelegramAuthControllerAuthorizeByFirebaseMutationRequest>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramAuthAuthorizeByFirebaseMutationKey();

  return useMutation<
    TelegramAuthControllerAuthorizeByFirebaseMutationResponse,
    ResponseErrorConfig<TelegramAuthControllerAuthorizeByFirebase401 | TelegramAuthControllerAuthorizeByFirebase403>,
    { data: TelegramAuthControllerAuthorizeByFirebaseMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return telegramAuthAuthorizeByFirebase(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
